import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./upcalcomp.css";
import { TfiAlignJustify } from "react-icons/tfi";

import ButtonGroup from '@mui/material/ButtonGroup';
import { BiFoodMenu, BiHomeHeart } from "react-icons/bi";

import { useNavigate } from 'react-router-dom';


export default function Topslider2() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  function edit(){
        let path = '/edit'; 
        navigate(path);
  }
  function invoice(){
        let path = '/adminestimate'; 
        navigate(path);
  }
  function delpge(){
    let path = '/delete'; 
    navigate(path);
}

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="topbar">
        <div className="topbar1" >
          <button className="topbtn" onClick={handleShow}>
            <TfiAlignJustify  className="topbtnicon"/>
          </button>
        </div>
        <div className="topbar2">  
        <a href= 'https://trendingdecors.in/'>  <br/> TRENDING DECORS</a>
        </div>
      </div>
     

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
          <BiFoodMenu />
          &nbsp;
          Menu 

            
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
